export function handleNotebookResponse(
  status: number | undefined,
  action: string,
  message?: string
): void {
  const messageText = message ? ` Message: ${message}` : '';
  
  switch (status) {
    case 200:
     console.log(`${messageText}`);
      break;
    case 204:
     console.log(`${messageText}`);
      break;
    case 400:
      console.error(`${action} failed: Bad Request.${messageText}`);
      break;
    case 401:
      console.error(`${action} failed: Unauthorized.${messageText}`);
      break;
    case 402:
      console.error(`${action} failed: gateway: quota exceeded.${messageText}`);
      break;
    case 403:
      console.error(`${action} failed: Forbidden.${messageText}`);
      break;
    case 404:
      console.error(`${action} failed: Not Found.${messageText}`);
      break;
    default:
      console.warn(`${action} failed: Unknown status code ${status}.${messageText}`);
  }
}
